export default __webpack_public_path__ + "static/media/img3.eeb1acbb.jpeg";